import React from 'react';
import Logo from '../resources/logo.png';
import '../styles.css'
import './Footer.css'; // Asegúrate de importar el CSS

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        {/* Logo */}
        <div className="footer-logo">
          <img src={Logo} alt="Logo" />
        </div>

        {/* Secciones */}
        <div className="footer-links">
          <h3>Secciones</h3>
          <ul>
            <li><a href="/">Inicio</a></li>
            <li><a href="/servicios">Servicios</a></li>
            <li><a href="/sobremi">Sobre mí</a></li>
            <li><a href="/contacto">Contacto</a></li>
             <a
                href="https://www.doctoralia.com.mx/daniel-sanchez-sarabia/ginecologo/oaxaca-de-juarez#profile-reviews"
                target="_blank"
                rel="noopener noreferrer"
              >
                Opiniones
              </a>
          </ul>
        </div>
      </div>

     
    </footer>
  );
};

export default Footer;
